import { Match, Switch, type JSX } from "solid-js";

import { createMatcher } from "~/util/solid";

import { GapArt } from "./gap_art";
import { ToothArt } from "./tooth_art";
import type { WaitStage } from "./wait_paths";

const isArt = createMatcher("art");

/** One step of an "If it waits" strip: one tooth from the side, or the gap scene. */
export function WaitStageArt(props: { stage: WaitStage; title: string }): JSX.Element {
  return (
    <Switch>
      <Match when={isArt(props.stage, "gap")}>
        {(stage) => <GapArt spec={stage().spec} title={props.title} />}
      </Match>
      <Match when={isArt(props.stage, "tooth")}>
        {(stage) => <ToothArt spec={stage().spec} title={props.title} />}
      </Match>
    </Switch>
  );
}
